/**
 * Parse a date string (e.g. "2026-02-02" or "2026-02-02T00:00:00.000Z")
 * as a LOCAL date, avoiding the UTC-midnight interpretation that causes
 * dates to shift back one day in timezones west of UTC (e.g. EST).
 *
 * JavaScript's `new Date("2026-02-02")` treats date-only strings as UTC,
 * so in EST (UTC-5) it becomes Feb 1st 7 PM — the previous day.
 * This helper always returns midnight in the user's local timezone.
 */
/** Convert decimal hours (e.g. 95.8) to HH:MM string (e.g. "95:48") */
export function formatHoursMinutes(decimal: number): string {
  const h = Math.floor(decimal);
  const m = Math.round((decimal - h) * 60);
  return `${h}:${String(m).padStart(2, '0')}`;
}

export function parseLocalDate(dateStr: string): Date {
  const d = dateStr.substring(0, 10); // handles both "2026-02-02" and "2026-02-02T00:00:00.000Z"
  const [y, m, day] = d.split('-').map(Number);
  return new Date(y, m - 1, day);
}
